module.exports = __webpack_public_path__ + "media/components/src/assets/images/image_text2/8-a142c8740e02cf60aa2e83454b34825c.jpg";